import { render } from "./HrmisCrudModule.vue?vue&type=template&id=5d562fe5&scoped=true"
import script from "./HrmisCrudModule.vue?vue&type=script&lang=js"
export * from "./HrmisCrudModule.vue?vue&type=script&lang=js"

import "./HrmisCrudModule.vue?vue&type=style&index=0&id=5d562fe5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d562fe5"]])

export default __exports__